<div class="overview-wrapper position-relative">
    <button class="btn btn-primary position-absolute btn-add-task" *ngIf="activeRoute == 'petition-status'" (click)="handleAddClick()"><span class="common-bene-class-for-translation">Add/Edit Task Details</span></button>
    <div class="overview-sidebar border-right border-bottom">
        <div class="px-3">
            <div>
                <span class="rounded-50" style="width: 80px; height: 80px"><img class="w-100"></span>
                <span class="d-flex flex-column">
                   <h6 class="mb-0 font-weight-bold" style="color: #19A0DA">{{superTaskDetails.sponsorFirstName}} {{superTaskDetails.sponsorLastName}}</h6>
                   <span class="common-bene-class-for-translation">Task ID: {{superTaskDetails.superTaskId}}</span>
                </span>
            </div>
            <div class="mt-1 common-bene-class-for-translation">Dependants : <span style="color: #19A0DA">{{applicants}}</span></div>
        </div>
        <div class="px-3 mt-3 py-3 border-top">
            <div class="common-bene-class-for-translation">
                Visa Details
            </div>
        </div>
        <p-accordion [activeIndex]="0" class="sidebar-accordion">
            <p-accordionTab>
                <ng-template pTemplate="header">{{superTaskDetails.visaType?.description}}  <!--span style="color: #19A0DA">(In Progress)</span--></ng-template>
                <ng-template pTemplate="content">
                    <div class="p-2 common-bene-class-for-translation" [ngClass]="activeRoute == 'petition-status' ? 'activeRoute' : ''" (click)="navigate('petition-status')">Petition Status</div>
                    <div class="p-2 common-bene-class-for-translation" [ngClass]="activeRoute == 'beneficiary-timeline'? 'activeRoute' : ''" (click)="navigate('beneficiary-timeline')">Timeline</div>
                    <!-- <div class="p-2 common-bene-class-for-translation" [ngClass]="activeRoute == 'beneficiary-document-checklist'? 'activeRoute' : ''" (click)="navigate('beneficiary-document-checklist')">Document Checklist</div> -->
                </ng-template>
            </p-accordionTab>
        </p-accordion>
        
    </div>
    
    <div class="content-area">
        <router-outlet></router-outlet>
    </div>
</div>
